import React from 'react';
import Button from '~/components/button';
import GeniusModal from '~/components/genius_modal';
const ArchiveProject = (props) => {
    const { isVisible, onHide, handleArchiveProject, selectedProject } = props;
    const message = `Are you sure you want to ${selectedProject.isArchived ? 'unarchive' : 'archive'} this folder?`;
    return (React.createElement(GeniusModal, { isModalShowing: isVisible, alertForm: true, onHide: onHide, bodyContent: React.createElement(React.Fragment, null,
            React.createElement("label", { className: 'modal-input-label', htmlFor: 'Location' }, message),
            React.createElement("div", { className: 'modal-project-name-wrapper' },
                React.createElement("div", { className: 'project-name center' },
                    React.createElement("i", { className: "fa-regular fa-folder-closed" }),
                    selectedProject.name))), footerContent: React.createElement("div", { className: 'action-button-wrapper' },
            React.createElement(Button, { className: 'modal-action-btn', primary: true, onClick: () => { onHide(); handleArchiveProject(); } }, selectedProject.isArchived ? 'Unarchive' : 'Archive')) }));
};
export default ArchiveProject;
